export const FEATURE_REQUEST_HANDLER = 'Upvoty';
